import { useRef, useCallback, useEffect } from 'react';

import { useVisibilityChange } from './useVisibilityChange';

const reload = () => window.location.reload();

export function useTimeoutReload(timeout: number) {
    const firstRenderTimestamp = useRef(Date.now());

    const onVisiblityChange = useCallback(() => {
        if (Date.now() > firstRenderTimestamp.current + timeout) {
            reload();
        }
    }, [timeout]);

    useVisibilityChange(onVisiblityChange);

    useEffect(() => {
        const t = window.setTimeout(reload, timeout);
        return () => window.clearTimeout(t);
    }, [timeout]);
}
